import { connect } from 'react-redux';

import { saveTriggerInputField } from 'app/developer-v3/Actions';
import {
  currentTrigger,
  selectIsServiceSetup,
} from 'app/developer-v3/selectors';

import TriggerInputsWrapper from './TriggerInputsWrapper';

const mapStateToProps = state => ({
  isTriggerSetup: selectIsServiceSetup(state),
  trigger: currentTrigger(state),
});

export default connect(mapStateToProps, {
  saveTriggerUpdates: saveTriggerInputField,
})(TriggerInputsWrapper);
